
define('text!modules/T1App/edit/team/templates/search.html',[],function () { return '<strand-input class="search-input search-team-users" placeholder="Search" search clear></strand-input>';});

